// ts-ignore upstream dep needs to be typed
import enviro from 'enviro';
const DEBUG_SERVICE = 'CONTENT_EMBED_UI';
let debug = false;
try {
  // This checks for the truthiness of the
  // `CONTENT_EMBED_UI_DEBUG` localstorage key
  debug = enviro.debug(DEBUG_SERVICE) === 'true';
} catch (e) {
  // eslint-disable-next-line no-empty
}
const prefix = '[content-embed-ui]';
function log(id, ...args) {
  console.log(prefix, `"${id}"`, ...args);
}
export function getLogger() {
  if (debug) {
    return log;
  }
  return () => {};
}